import { Button } from '@platform/components';
import { navigate } from 'wouter/use-browser-location';
import flaviaPhoto from '../../../assets/flavia_photo.png';
import gracePhoto from '../../../assets/grace_photo.png';
import lewisPhoto from '../../../assets/lewis_photo.png';
import confetti from '../../../assets/confetti.png';
import { ROUTES } from '../../routes/consts';

const REVIEW_TEAM = [
  { name: 'Lewis', role: 'Entrepreneur in Residence', photo: lewisPhoto },
  { name: 'Flavia', role: 'Matching Expert', photo: flaviaPhoto },
  { name: 'Grace', role: 'Recommendation Engineer', photo: gracePhoto },
];

export const ProjectSubmittedScreen = () => {
  const projectUrl = `/platform/dashboard/my-projects?tab=Under%20review`;

  return (
    <div className='fixed inset-bs-18 inset-0 z-25 min-h-screen bg-gray-50 flex flex-col w-full items-center px-4 pt-20 pb-12'>
      <p className='text-2xl text-center font-bold text-gray-900 mb-6'>
        <span className='text-success-500'>Submitted!</span> MovingWorlds is reviewing your project.
      </p>

      <div className='bg-white rounded-2xl border border-gray-200 shadow-xs w-full max-w-[700px] flex flex-col items-center overflow-hidden'>
        <div className='flex flex-col items-center gap-2 text-center my-8 px-10'>
          <p className='text-lg font-bold text-gray-700'>Say hi to your review team 👋</p>
          <p className='text-sm text-gray-500'>
            We read every project personally before it is published, so the professionals who match
            with you are ready to make an impact.
          </p>
        </div>

        <div
          className='w-full h-40 flex items-end justify-center gap-6 relative mb-8 bg-center bg-no-repeat bg-contain'
          style={{ backgroundImage: `url(${confetti})`, backgroundSize: "70%" }}
        >
          {REVIEW_TEAM.map((member, i) => (
            <div
              key={member.name}
              className={`flex flex-col items-center gap-2 ${i === 1 ? 'mb-4' : ''}`}
            >
              <img
                src={member.photo}
                alt={member.name}
                className='w-20 h-20 rounded-full object-cover border-2 border-white shadow-sm'
              />
              <div className='flex flex-col items-center'>
                <span className='text-sm font-medium text-gray-800 pb-1'>{member.name}</span>
                <span className='text-xs font-medium text-center text-gray-500'>{member.role}</span>
              </div>
            </div>
          ))}
        </div>

        <div className='h-px w-[700px] bg-gray-100'/>

        <div className='bg-secondary-brand-25 h-[80px] w-full flex justify-center items-center px-4'>
          <p className='text-sm text-gray-600 text-center'>
            <span className='font-bold'>We will be in touch within 3 business days.</span> If we
            have any questions before publishing your project, we will reach out directly.
          </p>
        </div>
      </div>

      <div className='flex flex-col w-full max-w-[700px] gap-3 mt-6'>
        <Button variant='primary' size='lg' href={projectUrl}>
          View your project
        </Button>
        <Button
          variant='secondary-gray'
          size='lg'
          onPress={() => navigate(`/platform${ROUTES.DASHBOARD}`)}
        >
          Back to Home
        </Button>
      </div>
    </div>
  );
};
